(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mimoya-ba-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.mbaBound === '1') return;
      root.dataset.mbaBound = '1';

      var track = root.querySelector('[data-ref="mba-track"]');
      if (!track) return;

      var prev = root.querySelectorAll('[data-ref="mba-prev"]');
      var next = root.querySelectorAll('[data-ref="mba-next"]');

      function step() {
        var card = track.querySelector('[data-ref="mba-card"]');
        if (!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function refresh() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft >= max;
        prev.forEach(function (b) { b.disabled = atStart; });
        next.forEach(function (b) { b.disabled = atEnd || max <= 0; });
      }

      prev.forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      });

      next.forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          refresh();
          ticking = false;
        });
      });

      window.addEventListener('resize', refresh);
      refresh();
      window.setTimeout(refresh, 400);
    }

    function initAll() {
      document.querySelectorAll('[data-ref="mba-root"]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimoya-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.miBound === '1') return;
      root.dataset.miBound = '1';

      if (!root.classList.contains('mimoya-ing--reveal')) return;

      var grid = root.querySelector('[data-ref="mi-grid"]');
      if (!grid) return;

      var cards = grid.querySelectorAll('[data-ref="mi-card"]');

      function showAll() {
        cards.forEach(function (card) { card.classList.add('is-inview'); });
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        showAll();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          showAll();
        });
      }, { threshold: 0.15 });

      io.observe(grid);
    }

    function initAll() {
      document.querySelectorAll('[data-ref="mi-root"]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimoya-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRoot(root) {
      if (root.dataset.mstBound === '1') return;
      root.dataset.mstBound = '1';

      var stats = root.querySelectorAll('[data-ref="mst-stat"]');

      function reveal(stat) {
        stat.classList.add('is-inview');
        var n = stat.querySelector('[data-ref="mst-count"]');
        if (!n) return;
        var target = parseInt(n.dataset.value, 10) || 0;
        var start = null;
        function tick(ts) {
          if (!start) start = ts;
          var k = Math.min((ts - start) / 1200, 1);
          k = 1 - Math.pow(1 - k, 3);
          n.textContent = Math.round(target * k) + '%';
          if (k < 1) window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      }

      if (!('IntersectionObserver' in window)) {
        stats.forEach(function (stat) {
          stat.classList.add('is-inview');
          var n = stat.querySelector('[data-ref="mst-count"]');
          if (n) n.textContent = (parseInt(n.dataset.value, 10) || 0) + '%';
        });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          reveal(entry.target);
        });
      }, { threshold: 0.4 });

      stats.forEach(function (stat) { io.observe(stat); });
    }

    function initAll() {
      document.querySelectorAll('[data-ref="mst-root"]').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
